import { render, staticRenderFns } from "./AppointmentCell.vue?vue&type=template&id=ed20a302"
import script from "./AppointmentCell.vue?vue&type=script&lang=js"
export * from "./AppointmentCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports